import React, { useEffect, useState } from 'react';
import { getEntryById } from '@grubhubprod/umami-library/dist/contentful';
import { get } from '@grubhubprod/umami-library/dist/nodash/get';
import { Square } from '@grubhubprod/gh-cookbook-react';
import { getConfig } from 'src/utilities/config';
import { getSafeHtml } from 'src/utilities/safeHtmlUtils';

interface IContentfulTextFragment {
  id: string;
  staticwebTextfragmentContentblob: string;
  staticwebTextfragmentTitle: string;
}
interface IContentfulResponse {
  data: IContentfulTextFragment[];
}

export function Footer(): JSX.Element {
  const {
    contentful: { footerEntryId },
  } = getConfig();

  const [footerHtml, setFooterHtml] = useState<string>();

  useEffect(() => {
    async function getContentfulFooter() {
      try {
        const response: IContentfulResponse = await getEntryById(
          footerEntryId,
          {
            include: 2,
          }
        );

        const footerData = get(
          response,
          'data',
          0,
          'staticwebTextfragmentContentblob'
        );

        const sanitizedFooterHtml = getSafeHtml(footerData);
        setFooterHtml(sanitizedFooterHtml);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
      }
    }

    getContentfulFooter();
  }, [footerEntryId]);

  if (footerHtml) {
    // eslint-disable-next-line react/no-danger
    return (
      <Square
        borderTop="1px"
        borderColor="lightLine"
        dangerouslySetInnerHTML={{ __html: footerHtml }}
      />
    );
  }

  return null;
}
